import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";

const TONE = {
  paid: "bg-[#E3F1E4] text-[#2F6B3A]",
  capture_pending: "bg-[#FFF1CC] text-[#8A5A10]",
  disputed: "bg-[#FFE1CF] text-[#A84A32]",
  refunded: "bg-[#ECE7E1] text-[#5A524B]",
  reversed: "bg-[#ECE7E1] text-[#5A524B]",
  refunded_duplicate: "bg-[#ECE7E1] text-[#5A524B]",
  failed: "bg-[#F9D9D3] text-[#9A2F22]",
};
const LABEL = { capture_pending: "pending", refunded_duplicate: "duplicate refunded" };
const fmt = (d) => (d ? new Date(d).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" }) : "—");

const Id = ({ label, value, testid }) =>
  value ? (
    <div className="min-w-0">
      <p className="text-[11px] uppercase tracking-wide text-[#8A7F76]">{label}</p>
      <p data-testid={testid} className="break-all font-mono text-xs text-[#2C2A28]">{value}</p>
    </div>
  ) : null;

export const StatusPill = ({ status }) => (
  <span className={`inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${TONE[status] || "bg-[#ECE7E1] text-[#5A524B]"}`}>
    {LABEL[status] || status}
  </span>
);

export const PaymentRow = ({ o }) => {
  const [open, setOpen] = useState(false);
  const id = o.order_number;
  return (
    <li data-testid={`payment-row-${id}`} className="rounded-2xl border border-[#4A4540]/10 bg-white">
      <button data-testid={`payment-row-toggle-${id}`} onClick={() => setOpen(!open)}
        className="grid w-full grid-cols-[1fr_auto] items-center gap-3 px-4 py-3 text-left sm:grid-cols-[150px_1fr_110px_120px_24px]">
        <span className="text-xs text-[#8A7F76] sm:text-sm">{fmt(o.created_at)}</span>
        <span className="col-span-2 min-w-0 sm:col-span-1">
          <span className="block truncate font-semibold text-[#2C2A28]">{o.product_label}{o.year ? ` · ${o.year}` : ""}</span>
          <span className="block truncate text-xs text-[#8A7F76]">{o.username} · {id} · {o.provider}</span>
        </span>
        <span className="font-semibold text-[#2C2A28]">A${Number(o.amount || 0).toFixed(2)}</span>
        <span className="flex items-center justify-end gap-2 sm:justify-start"><StatusPill status={o.payment_status} /></span>
        <CaretDown size={16} className={`hidden transition-transform sm:block ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`payment-details-${id}`} className="space-y-4 border-t border-[#4A4540]/10 px-4 py-4">
          <div className="grid gap-3 sm:grid-cols-3">
            <Id label="PayPal order ID" value={o.paypal_order_id} testid={`paypal-order-id-${id}`} />
            <Id label="PayPal transaction (capture) ID" value={o.paypal_capture_id} testid={`paypal-capture-id-${id}`} />
            <Id label="Stripe payment ID" value={o.stripe_payment_intent_id} />
            <Id label="Dispute ID" value={o.dispute?.id} />
            <Id label="Customer email" value={o.email} />
            <Id label="Paid / refunded" value={`${fmt(o.paid_at)} / ${fmt(o.refunded_at)}`} />
          </div>
          <div>
            <p className="mb-2 text-sm font-semibold text-[#2C2A28]">Changes</p>
            {o.changes.length ? (
              <ol className="space-y-2 border-l-2 border-[#F2B24C] pl-4">
                {o.changes.map((c, i) => (
                  <li key={i} data-testid={`payment-change-${id}-${i}`} className="text-sm">
                    <span className="font-semibold text-[#2C2A28]">{c.action.replaceAll("_", " ")}</span>
                    <span className="text-[#8A7F76]"> · {fmt(c.at)} · {c.event_type}</span>
                    <p className="text-[#4A4540]">{c.reason}</p>
                    {c.transaction_id && <p className="break-all font-mono text-xs text-[#8A7F76]">Transaction {c.transaction_id}</p>}
                  </li>
                ))}
              </ol>
            ) : (
              <p className="text-sm text-[#8A7F76]">No recorded changes (older payment, before change tracking).</p>
            )}
          </div>
        </div>
      )}
    </li>
  );
};
